export default __webpack_public_path__ + "static/NotoSans-Regular-eae34fa8f1e0c4c6d797589fa0ba4cd9.ttf";